let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5k7Nq")).then(() => parcelRequire('ga2WT'));